import http from 'utils/http';
import { FLOW_MANAGEMENT } from 'redux/actions/Types';
import { SyntheticRedux } from 'synthetic-redux';
import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { flowManagement } from 'utils/urlConstants';


const fetchOrgAvailableFlows = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.FETCH_ORG_AVAILABLE_FLOWS }, 'list',
);

fetchOrgAvailableFlows.ignite = (orgId, accId, payload) => fetchOrgAvailableFlows
  .actions.ignite({
    errorMeta: 'Flow Management : Fetch Org Available List',
    method: http.post,
    payload,
    url: flowManagement.orgAvailableFlows(accId, orgId),
  });

const fetchOrgListFilters = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.FETCH_ORG_LIST_FILTERS }, 'list',
);

fetchOrgListFilters.ignite = (accId, orgId) => fetchOrgListFilters.actions.ignite({
  errorMeta: 'Flow Management : Fetch Org Filters List',
  method: http.get,
  url: flowManagement.orgListFilters(accId, orgId),
});

const fetchFlowDetail = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.FETCH_FLOW_DETAILS }, 'response',
);

fetchFlowDetail.ignite = (orgId, fId) => fetchFlowDetail.actions.ignite(
  {
    errorMeta: 'Flow Management : Fetch Flow Details',
    method: http.get,
    url: flowManagement.flowDetails(orgId, fId),
  },
);

const fetchOrgProvisionedFlows = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.FETCH_ORG_PROVISIONED_FLOWS }, 'list',
);

fetchOrgProvisionedFlows.ignite = (accId, orgId, payload) => fetchOrgProvisionedFlows
  .actions.ignite({
    errorMeta: 'Flow Management : Fetch Org Provisioned List',
    method: http.post,
    payload,
    url: flowManagement.orgProvisionedFlows(accId, orgId),
  });

const fetchProvisionedFlowAccAndOrg = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.FETCH_PROVISIONED_FLOW_ACC_AND_ORG }, 'list',
);

fetchProvisionedFlowAccAndOrg.ignite = flowId => fetchProvisionedFlowAccAndOrg.actions.ignite({
  errorMeta: 'Flow Management : Fetch Provisioned Flow Acc and Org',
  method: http.get,
  url: flowManagement.provisionedFlowAccAndOrg(flowId),
});

const provisionOrgFlows = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.PROVISION_ORG_FLOWS }, 'response',
);

provisionOrgFlows.ignite = (accId, orgId, payload) => provisionOrgFlows.actions.ignite({
  errorMeta: 'Flow Management : Provision Organization Flows',
  method: http.post,
  payload,
  url: flowManagement.provisionOrgFlows(accId, orgId),
});

const provisionAccountFlows = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.PROVISION_PLATFORM_FLOWS }, 'response',
);

provisionAccountFlows.ignite = payload => provisionAccountFlows.actions.ignite({
  errorMeta: 'Flow Management : Provision Flows',
  method: http.post,
  payload,
  url: flowManagement.flowsProvisioning,
});

const provisionFlows = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.PROVISION_FLOWS }, 'response',
);

provisionFlows.ignite = payload => provisionFlows.actions.ignite({
  errorMeta: 'Flow Management : Provision Flows (Consistent Endpoint)',
  method: http.post,
  payload,
  url: flowManagement.flowsProvisioning,
});

const deprovisionFlow = new SyntheticRedux(
  { type: FLOW_MANAGEMENT.DEPROVISION_FLOW }, 'response',
);

deprovisionFlow.ignite = (entityType, entityId, flowID) => deprovisionFlow.actions.ignite({
  errorMeta: 'Flow Management : Deprovision Flow',
  method: http.put,
  url: flowManagement.deprovisionFlow(entityType, entityId, flowID),
});


const synFlowManagementReducer = combineReducers({
  deprovisionFlow: deprovisionFlow.reducer,
  orgAvailableFList: fetchOrgAvailableFlows.reducer,
  orgProvisionedFList: fetchOrgProvisionedFlows.reducer,
  orgListFilters: fetchOrgListFilters.reducer,
  provisionedFlowAccAndOrg: fetchProvisionedFlowAccAndOrg.reducer,
  provisionOrgFlows: provisionOrgFlows.reducer,
  provisionAccountFlows: provisionAccountFlows.reducer,
  provisionFlows: provisionFlows.reducer,
  flowDetail: fetchFlowDetail.reducer,
});

function* flowManagementSaga() {
  yield all([
    deprovisionFlow.sagaEffect,
    fetchOrgAvailableFlows.sagaEffect,
    fetchOrgListFilters.sagaEffect,
    fetchOrgProvisionedFlows.sagaEffect,
    fetchProvisionedFlowAccAndOrg.sagaEffect,
    fetchFlowDetail.sagaEffect,
    provisionAccountFlows.sagaEffect,
    provisionOrgFlows.sagaEffect,
    provisionFlows.sagaEffect,
  ]);
}

export {
  deprovisionFlow,
  fetchOrgAvailableFlows,
  fetchOrgListFilters,
  fetchOrgProvisionedFlows,
  fetchProvisionedFlowAccAndOrg,
  fetchFlowDetail,
  provisionAccountFlows,
  provisionOrgFlows,
  provisionFlows,
  synFlowManagementReducer,
  flowManagementSaga,
};
